import { PkBadge } from '@uefadigital/panenka-react';
import { memo, useMemo } from 'react';

import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

const AssociationBadge = ({ association, isWide }: { association: string; isWide?: boolean }) => {
  const t = useTranslateFn();

  const associationLogo = useMemo(() => {
    let logo = `${window.imgBaseUrl}/imgml/uefacom/insideuefa/uefa_logo${isWide ? '_white' : ''}.png`;
    if (association && association !== 'UEFA') logo = `${window.imgBaseUrl}/imgml/flags/70x70/${association}.png`;
    return logo;
  }, [association, isWide]);

  const translatedAssociation = t(association);

  const associationLabel = useMemo(() => {
    return association === 'UEFA' ? 'UEFA' : translatedAssociation;
  }, [association, translatedAssociation]);

  return (
    <div className={`pk-mb--xs ${styles.association}`}>
      <PkBadge alt={associationLabel} fallbackImage='ntc-generic-badge-01' src={associationLogo} size={20} />
      <span className='pk-ml--xs'>{associationLabel}</span>
    </div>
  );
};

export default memo(AssociationBadge);
